import t from "react";
import c from "classnames";
import m from "./index174.mjs";
import l from "./index175.mjs";
import n from "./index176.mjs";
import r from "./index177.mjs";
var i = /* @__PURE__ */ ((e) => (e.SUCCESS = "success", e.ERROR = "error", e.NEUTRAL = "neutral", e))(i || {});
const _ = ({
  index: e,
  message: o,
  state: a,
  onClose: s
}) => /* @__PURE__ */ t.createElement(
  "div",
  {
    id: `toast-${e}`,
    className: c(r.toast, r["toast_" + a]),
    "data-testid": `toast-${e}`
  },
  {
    success: /* @__PURE__ */ t.createElement("div", { className: r.icon }, /* @__PURE__ */ t.createElement(m, { "data-testid": "icon_success" })),
    error: /* @__PURE__ */ t.createElement("div", { className: r.icon }, /* @__PURE__ */ t.createElement(l, { "data-testid": "icon_error" })),
    neutral: null
  }[a],
  /* @__PURE__ */ t.createElement("h5", { "data-testid": `toast-message-${e}` }, o),
  s ? /* @__PURE__ */ t.createElement("div", { className: r.icon_close }, /* @__PURE__ */ t.createElement(n, { onClick: s, "data-testid": "icon_close" })) : null
);
export {
  _ as Toast,
  i as ToastState
};
